import billListView from "../../../components/pos/bill_list";
import billHoldingListView from "../../../components/pos/bill_holding_list";
import billCreditListView from "../../../components/pos/bill_credit_list";
import customerListView from "../../../components/pos/customer_list";
import exportMoneyView from "../../../components/pos/export_shift";
import incomeMoneyView from "../../../components/pos/income_shift";
import receiveProducts from "../../../components/pos/receive_products";
import creditPayView from "../../../components/pos/creditlist_pay";
// import billListAll from '../../../views/sale_bill.vue'
import billListAll from "../../../components/pos/bill_list_all";
import riceStk from "../../../components/pos/rice_stk";
import stockOutList from "../../../components/pos/stock_out_list";
import stockInList from "../../../components/pos/stock_in_list";
import Swal from "sweetalert2";
import api from "../../../services/service_pos";
import apiMarim from "../../../services/service_undefined_v2";
import moment from "moment";
import confirmSaleEgg from "../../../components/pos/confirm_sale_egg";
import confirmSaleRiceMar from "../../../components/pos/confirm_sale_rice_mar";

export default {
  components: {
    billListView,
    billHoldingListView,
    customerListView,
    billCreditListView,
    exportMoneyView,
    incomeMoneyView,
    receiveProducts,
    creditPayView,
    billListAll,
    riceStk,
    stockOutList,
    stockInList,
    confirmSaleEgg,
    confirmSaleRiceMar
  },
  data() {
    return {
      tool_type: 0,
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      hostshift: JSON.parse(sessionStorage.hostshift),
      receive_show: false,
      stockIn: "0",
      stockOut: "0"
    };
  },
  methods: {
    getNotificationTransfer() {
      apiMarim.notificationTransfer({}, result => {
        if (result.status) {
          // eslint-disable-next-line no-unused-expressions
          this.stockIn = result.data.data.stockIn;
          this.stockOut = result.data.data.stockOut;
        }
      });
    },
    getSaleAllDay() {
      this.$store.commit("Loading");
      api.getSaleOnHost(
        this.REST_URL,
        {
          host_code: this.hostshift.host_code,
          company_id: 1,
          branch_id: 1,
          begin_date: moment(new Date()).format("YYYYMMDD") + " 000001",
          end_date: moment(new Date()).format("YYYYMMDD") + " 235959"
        },
        this.header,
        result => {
          if (result.response === "success") {
            var amount = 0;
            result.data.forEach(val => {
              if (val["holding_status"] === 0) {
                amount += val["total_amount"];
              }
            });
            Swal.fire({
              title:
                "ยอดขาย" +
                this.hostshift.host_name +
                " ประจำวันที่ " +
                this.dateFormatDMY(new Date()),
              html:
                '<b style="color: #555; font-size: 65px;"> ' +
                this.numberFormat(amount) +
                " บาท</b>",
              icon: "success"
            });
          } else {
            this.$notification["warning"]({
              message: "ทำการพักบิลไม่ได้",
              description: result.message
            });
          }
          this.$store.commit("Loading");
        },
        error => {
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          this.$store.commit("Loading");
        }
      );
    },
    devNow() {
      this.$notification["warning"]({
        message: "แจ้งเตือนระบบ",
        description: "กำลังพัฒนา"
      });
    },
    resetStockEgg() {
      this.$store.commit("Loading");
      Swal.fire({
        title: "ลบข้อมูลคลังไข่",
        text: "ท่านต้องการลบข้อมูลคลังไข่ ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง"
      }).then(result => {
        if (result.value) {
          //
          // var obj = {
          //   cash_amount: 0,
          //   bank_amount: 0,
          //   change_amount: 0,
          //   credit_amount: 0,
          //   chq_amount: 0,
          //   promptpay_amount: 0,
          //   coupon_amount: 0,
          //   expense_amount: 0,
          //   my_description: "",
          //   host_code: this.hostshift.host_code,
          //   id: this.hostshift.id
          // };
          // api.closeShift(
          //   this.REST_URL,
          //   obj,
          //   this.header,
          //   result => {
          //     if (result.response === "success") {
          //       this.$store.commit("clearOrderPayment");
          //       this.openCashBox(this.hostshift);
          //       $("#ShiftModal").modal("show");
          //     } else {
          //       this.$notification["warning"]({
          //         message: "ปิดการขายไม่ได้",
          //         description: result.message
          //       });
          //     }
          //     this.$store.commit("Loading");
          //   },
          //   error => {
          //     alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          //     this.$store.commit("Loading");
          //   }
          // );
          apiMarim.resetStockEgg(
            { username: this.$store.state.user.username },
            this.header,
            results => {
              if (results.status) {
                Swal.fire({
                  icon: "success",
                  title: "ลบข้อมูลคลังไข่ สำเร็จ",
                  showConfirmButton: false,
                  timer: 2000
                });
              } else {
                lert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
              }
            }
          );
        }
        this.$store.commit("Loading");
      });
    }
  },
  mounted() {
    $("body").on(
      "hidden.bs.modal",
      ".modal",
      function() {
        $(this).removeData("bs.modal");
        this.$store.state.receive_show = false;
      }.bind(this)
    );
    $("#itemStockOutInfo").on(
      "hide.bs.modal",
      function() {
        this.getNotificationTransfer();
        // eslint-disable-next-line no-extra-bind
      }.bind(this)
    );
    $("#itemStockOutInfo").on(
      "hide.bs.modal",
      function() {
        this.getNotificationTransfer();
        // eslint-disable-next-line no-extra-bind
      }.bind(this)
    );
    $("#ToolModalTransferIn").on(
      "hide.bs.modal",
      function() {
        this.getNotificationTransfer();
        // eslint-disable-next-line no-extra-bind
      }.bind(this)
    );
    $("#ToolModalTransferOut").on(
      "hide.bs.modal",
      function() {
        this.getNotificationTransfer();
        // eslint-disable-next-line no-extra-bind
      }.bind(this)
    );

    $("#ToolModalSaleEgg").on(
      "hide.bs.modal",
      function() {
        // eslint-disable-next-line no-extra-bind
      }.bind(this)
    );
    $("#ToolModalSaleRiceMar").on(
      "hide.bs.modal",
      function() {
        // eslint-disable-next-line no-extra-bind
      }.bind(this)
    );
    this.getNotificationTransfer();
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/pos/tool.js